
import './App.css';
import React,{useEffect,useState} from 'react';
import FsLightbox from 'fslightbox-react';
import './Gallery.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'slick-carousel/slick/slick.css'; 
import 'slick-carousel/slick/slick-theme.css';
import Slider from "react-slick";
import "animate.css";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { IoMenuSharp } from "react-icons/io5";
import axios from "axios";
import { IoMdClose } from "react-icons/io";
import { IoMdMail } from "react-icons/io";
import { FaPhoneAlt } from "react-icons/fa";
import { IoIosPin } from "react-icons/io";

// import 'cue.css';






function App() {
    const [formData, setFormData] = useState({
        fullname: "",
        lastname: "",
        email: "",
        phone: "",
        message: "",
      });
    
      const [status, setStatus] = useState("");
    
      const handleChange = (e) => {
        setFormData({
          ...formData,
          [e.target.name]: e.target.value,
        });
      };
    
      const handleSubmit = async (e) => {
        e.preventDefault();
        try {
          const response = await axios.post("/send-email", {
            fullname: formData.fullname ,
            lastname:formData.lastname,
            email: formData.email,
            phone: formData.phone,
            message: formData.message,
          });
          setStatus("Email sent successfully!");
        } catch (error) {
          setStatus("Error sending email. Please try again.");
          console.error("Error:", error);
        }
      };
  useEffect(() => {
    AOS.init();
  }, []);
  
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true
  };
 

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className="App">
 <header className="fixed w-full top-0 z-50 bg-black headnav">
 <div className="bg-gray-800 text-white py-2 text-sm">
  <div className="container mx-auto flex items-center justify-center space-x-4 topbar">
    <div className='topitem'> <IoIosPin  size={22}/>Srinvas garden layout, Sathnur Village,
    Bengaluru, Sathanur, Karnataka 560064</div>
    <div className='topitem'><FaPhoneAlt  size={18} style={{justifySelf:"center"}}/> +91 8618166429  | +91 8310722558</div>
    
    <div className='topitem'><IoMdMail size={22} /> <div style={{marginLeft:"2%"}}>upstreamsuites@gmail.com</div></div>
  </div>
</div>
      <div className="container mx-auto px-4">
        <div className="d-flex items-center justify-between h-16 navcont">
          {/* Logo */}
          <div className="flex-shrink-0">
            <a href="index.html" className="block">
              <div className="d-flex items-center">
                <img src='./uslogo.png' style={{height:"10vh"}}/>
                <span className="navname1">
                <img src='./upstreams.png' style={{height:"10vh" }}/>
                </span>
                <span className="navname2">
                  SUITES
                </span>
              </div>
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:block desknav">
            <ul className="flex space-x-8 desknav">
              {['About', 'Rooms', 'Gallery', 'Contacts'].map((item) => (
                <li key={item}>
                  <a
                    href={`#${item.toLowerCase()}`}
                    className="text-white hover:text-yellow-400 transition-colors duration-200 js-scroll-trigger animated_link"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* Mobile Menu Button */}

        </div>
        <button
            className=" mnavb"
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
           
              {isMenuOpen ? (
                <IoMdClose />
              ) : (
                <IoMenuSharp />
              )}
            
          </button>
        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden mobnav ">
            <ul className="px-2 pt-2 pb-3 space-y-1 " >
              {['About', 'Rooms', 'Gallery', 'Contacts'].map((item) => (
                <li key={item} className='mt-2'>
                  <a
                    href={`#${item.toLowerCase()}`}
                    className="block px-3 py-2 text-white hover:text-yellow-400 transition-colors duration-200 js-scroll-trigger animated_link navitems"
                    onClick={toggleMenu}
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </header>
    {/* <!-- End Header --> */}

    <div className="hero full-height jarallax" style={{ backgroundColor: 'gray' }}>
  <img
    src="./img/h1.jpg"
    alt="Hero"
    className="img-fluid"
    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
  />
            <div class="wrapper opacity-mask d-flex align-items-center justify-content-center text-center animate_hero" data-opacity-mask="rgba(0, 0, 0, 0.6)">
            {/* <img src="./img/home1.jpg" alt="" class="img-fluid me-2" /> */}
            {/* <img src="./img/home1.jpg" alt="" class="img-fluid me-2" style={{height:'700px'}} /> */}
                <div class="container" >
                <small class="" style={{color:"white"}}>Welcome to Upstream Suites</small>
                <h3 class="" data-aos="fade-right" data-aos-duration="3000"  style={{color:"#ffc107"}}>Experience Luxury and Comfort<br/>Your Perfect Stay Awaits</h3>
                    
                </div>
              
                {/* <!-- /lang_wp --> */}
            </div>
        </div>

        <div class="bg_white" id="about">
            <div class="container margin_120_95">
                <div class="row justify-content-between flex-lg-row-reverse align-items-center">
                    <div class="col-lg-5">
                        <div class="parallax_wrapper">
                            <img src="./img/h2.jpg" alt="" class="img-fluid rounded-img"/>
                            <div data-cue="slideInUp" class="img_over"><span data-jarallax-element="-30"><img src="./img/home_1.jpg" alt="" class="rounded-img"/></span></div>
                        </div>
                    </div>
                    <div class="col-lg-5">
                        <div class="intro">
                            <div class="title">
                                <small>About us</small>
                                <h2>Welcome to Upstream Suites</h2>
                                <p className="lead text-center mb-5" data-aos="fade-right">
    Make yourself at home and enjoy a unique and luxurious experience at Upstream Suites, where comfort meets elegance in every detail.
  </p>
                            </div>
                            {/* <p class="lead">Vivamus volutpat eros pulvinar velit laoreet, sit amet egestas erat dignissim.</p> */}
                            <p>
        Indulge in spacious rooms, world-class services, and stunning views. Our suites are equipped with all the modern conveniences to make your stay memorable, ensuring relaxation and peace of mind.
      </p>
      <h3>Exclusive Features</h3>
      <ul>
      Luxurious rooms with modern amenities<br/>
      Complimentary Wi-Fi, 24/7 concierge service<br/>
      Gourmet dining and exclusive offers<br/>
      

        {/* <li>Luxurious rooms with modern amenities</li>
        <li>Convenient location in the heart of the city</li>
        <li>Complimentary Wi-Fi, 24/7 concierge service</li>
        <li>Gourmet dining and exclusive offers</li> */}
      </ul>
                        </div>
                    </div>
                </div>
                {/* <!-- /Row --> */}
                <hr class="more_margin"/>
                <div class="row mt-4">
                    <div class="col-lg-3 col-md-6">
                        <div class="box_facilities no-border" data-cue="">
                            <i class="icon-hotel-parking"></i>
                            <h3>Private Parking</h3>
                            <p>Enjoy hassle-free parking with our secure, convenient private parking spaces, exclusively available for our guests.</p>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6">
                        <div class="box_facilities no-border" data-cue="">
                            <i class="icon-hotel-disable"></i>
                            <h3>Comfortable Rooms</h3>
                            <p>Enjoy spacious and elegantly designed rooms, offering a perfect blend of comfort and luxury for your stay at Upstream Suite.</p>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6">
                        <div class="box_facilities no-border" data-cue="">
                            <i class="icon-hotel-dog"></i>
                            <h3>Excellent Service</h3>
                            <p>Experience personalized service with our attentive staff who are always available to meet your needs and ensure a memorable stay</p>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6">
                        <div class="box_facilities no-border" data-cue="">
                            <i class="icon-hotel-patio"></i>
                            <h3>24/7 Reception</h3>
                            <p>Our friendly reception team is available around the clock, ready to assist you with any queries or requests during your stay.</p>
                        </div>
                    </div>
                </div>
                {/* <!-- /Row --> */}
            </div>
        </div>
        {/* <!-- /About  --> */}
        {/* <div class="parallax_section_1 jarallax" data-jarallax data-speed="0.2">
            <img class="jarallax-img kenburns-2" src="./img/parallax_bg.jpg" alt=""/>
            <div class="wrapper opacity-mask d-flex align-items-center justify-content-center text-center" data-opacity-mask="rgba(0, 0, 0, 0.5)">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-lg-8">
                            <div class="title white">
                                <small class="mb-1">Testimonials</small>
                                <h2>What Clients Says</h2>
                            </div>
                            <div class="">
                                <div>
                                    <div class="box_overlay">
                                        <div class="pic">
                                            <figure><img src="./img/testimonial_1.jpg" alt="" class="img-circle"/>
                                            </figure>
                                            <h4>Roberta<small>12 Oct</small></h4>
                                        </div>
                                        <div class="comment">
                                            "Mea ad postea meliore fuisset. Timeam repudiare id eum, ex paulo dictas elaboraret sed, mel cu unum nostrud."
                                        </div>
                                    </div>
                              
                                </div>
                                <div>
                                    <div class="box_overlay">
                                        <div class="pic">
                                            <figure><img src="./img/testimonial_1.jpg" alt="" class="img-circle"/>
                                            </figure>
                                            <h4>Roberta<small>2 Nov</small></h4>
                                        </div>
                                        <div class="comment">
                                            "Mea ad postea meliore fuisset. Timeam repudiare id eum, ex paulo dictas elaboraret sed, mel cu unum nostrud."
                                        </div>
                                    </div>
                                  
                                </div>
                                <div>
                                    <div class="box_overlay">
                                        <div class="pic">
                                            <figure><img src="./img/testimonial_1.jpg" alt="" class="img-circle"/>
                                            </figure>
                                            <h4>Roberta<small>3 Dec</small></h4>
                                        </div>
                                        <div class="comment">
                                            "Mea ad postea meliore fuisset. Timeam repudiare id eum, ex paulo dictas elaboraret sed, mel cu unum nostrud."
                                        </div>
                                    </div>
                                  
                                </div>
                            </div>
                           
                        </div>
                    </div>
                </div>
            </div>
        </div> */}
        <div className="parallax_section_1 jarallax" data-jarallax data-speed="0.2">
      <img className="jarallax-img kenburns-2" src="./img/parallax_bg.jpg" alt="Background" />
      <div className="wrapper opacity-mask d-flex align-items-center justify-content-center text-center" data-opacity-mask="rgba(0, 0, 0, 0.5)">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="title white">
                <small className="mb-1">Testimonials</small>
                <h2>What Clients Say</h2>
              </div>
              <Slider {...settings} className="carousel_testimonials">
                <div>
                  <div className="box_overlay">
                    <div className="pic">
                      <figure>
                        <img src="./img/testimonial_1.jpg" alt="Roberta" className="img-circle" />
                      </figure>
                      <h4>Roberta<small>12 Oct</small></h4>
                    </div>
                    <div className="comment">
  "A truly wonderful experience! The room was comfortable, and the staff was friendly and attentive. Highly recommend!"
</div>
                  </div>
                </div>
                <div>
                  <div className="box_overlay">
                    <div className="pic">
                      <figure>
                        <img src="./img/testimonial_1.jpg" alt="Roberta" className="img-circle" />
                      </figure>
                      <h4>John <small>15 Oct</small></h4>

                    </div>
                    <div className="comment">
    "Great location, amazing service, and exceptional comfort. We had a great stay and will definitely return."
  </div>
                  </div>
                </div>
                <div>
                  <div className="box_overlay">
                    <div className="pic">
                      <figure>
                        <img src="./img/testimonial_1.jpg" alt="Roberta" className="img-circle" />
                      </figure>
                      <h4>Emily <small>20 Oct</small></h4>
                    </div>
                    <div className="comment">
    "The hotel exceeded our expectations. The view from our room was stunning, and the amenities were top-notch."
  </div>
                  </div>
                </div>
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </div>
        {/* <!-- /parallax_section_1--> */}
        <div class="container margin_120_95" id="rooms">
            <div class="title mb-4">
                <small data-cue="">Luxury experience</small>
                <h2 data-cue="" data-delay="200">Our Rooms</h2>
            </div>

            <div class="row_list_version_2" data-cue="" data-delay="300">
                <div class="row g-0 align-items-center">
                    <div class="col-xl-8">
                        <div class="">
                            <div class="item">
                                <a data-fslightbox="room_1" data-type="image" href="./img/rooms/g1.jpg"><img src="./img/rooms/g1.jpg" alt=""/></a>
                            </div>
                            {/* <div class="item">
                                <a data-fslightbox="room_1" data-type="image" href="./img/rooms/opt_1.jpg"><img src="./img/rooms/opt_1.jpg" alt=""/></a>
                            </div> */}
                        </div>
                        {/* <!-- /carousel --> */}
                    </div>
                    <div class="col-xl-4">
                        <div class="box_item_info" data-jarallax-element="-25">
                            {/* <small>From $150/night</small> */}
                            <h2>Double Room</h2>
                            <p>Beautiful design with modern furnishings including a glamorous bay window with your own private view of Lucerne.</p>
                            <div class="facilities clearfix">
                                <ul>
                                    <li>
                                        <i class="customicon-double-bed"></i> King Size Bed
                                    </li>
                                    <li>
                                        <i class="customicon-television"></i> 32 Inc TV
                                    </li>
                                </ul>
                            </div>
                        </div>
                        {/* <!-- /box_item_info --> */}
                    </div>
                    {/* <!-- /col --> */}
                </div>
                {/* <!-- /row --> */}
            </div>
            {/* <!-- /row_list --> */}
            <div class="row_list_version_2 inverted" data-cue="">
                <div class="row g-0 align-items-center">
                    <div class="col-xl-8 order-xl-2">
                        <div class="">
                            <div class="item">
                                <a data-fslightbox="room_2" data-type="image" href="./img/rooms/g2.jpg"><img src="./img/rooms/g2.jpg" alt=""/></a>
                            </div>
                            {/* <div class="item">
                                <a data-fslightbox="room_2" data-type="image" href="./img/rooms/opt_2.jpg"><img src="./img/rooms/opt_2.jpg" alt=""/></a>
                            </div> */}
                        </div>
                        {/* <!-- /carousel --> */}
                    </div>
                    <div class="col-xl-4 order-xl-1">
                        <div class="box_item_info" data-jarallax-element="-25">
                            {/* <small>From $190/night</small> */}
                            <h2>Deluxe Room</h2>
                            <p>Elegant interiors with modern decor, highlighted by a glamorous bay window that frames your exclusive vista of Lucerne.</p>
                            <div class="facilities clearfix">
                                <ul>
                                    <li>
                                        <i class="customicon-double-bed"></i> King Size Bed
                                    </li>
                                    <li>
                                        <i class="customicon-television"></i> 32 Inc TV
                                    </li>
                                </ul>
                            </div>
                        </div>
                        {/* <!-- /box_item_info --> */}
                    </div>
                    
                </div>
                {/* <!-- /row --> */}
            </div>
            {/* <!-- /row_list --> */}
            <div class="row_list_version_2" data-cue="">
                <div class="row g-0 align-items-center">
                    <div class="col-xl-8">
                        <div class="">
                            {/* <div class="item">
                                <a data-fslightbox="room_3" data-type="image" href="./img/rooms/3.jpg"><img src="./img/rooms/3.jpg" alt=""/></a>
                            </div> */}
                            <div class="item">
                                <a data-fslightbox="room_3" data-type="image" href="./img/rooms/g3.jpg"><img src="./img/rooms/g3.jpg" alt=""/></a>
                            </div>
                        </div>
                        {/* <!-- /carousel --> */}
                    </div>
                    <div class="col-xl-4">
                        <div class="box_item_info" data-jarallax-element="-25">
                            {/* <small>From $230/night</small> */}
                            <h2>Superior Room</h2>
                            <p>A stunning design featuring contemporary furnishings, complemented by a chic bay window offering a breathtaking private view of Lucerne.</p>
                            <div class="facilities clearfix">
                                <ul>
                                    <li>
                                        <i class="customicon-double-bed"></i> King Size Bed
                                    </li>
                                    <li>
                                        <i class="customicon-television"></i> 32 Inc TV
                                    </li>
                                </ul>
                            </div>
                        </div>
                     
                    </div>
                   
                </div>
                {/* <!-- /row --> */}
            </div>
            {/* <!-- /row_list --> */}

            <div class="title text-center mb-5">
                <small data-cue="">Luxury Suites Experience</small>
                <h2 data-cue="" data-delay="100">Main Facilities</h2>
            </div>
            <div class="row mt-4">
                <div class="col-xl-3 col-md-6">
                    <div class="box_facilities no-border" data-cue="">
                        <i class="customicon-bath-tub"></i>
                        <h3>Spacious Rooms</h3>
                        <p>Enjoy elegant and spacious rooms with all the modern comforts for a relaxed stay at Upstream Suites.</p>
                    </div>
                </div>
                <div class="col-xl-3 col-md-6">
                    <div class="box_facilities" data-cue="">
                        <i class="customicon-wifi"></i>
                        <h3>High-Speed Wifi</h3>
                        <p>Stay connected with high-speed internet throughout the property.</p>
                    </div>
                </div>
                <div class="col-xl-3 col-md-6">
                    <div class="box_facilities" data-cue="">
                        <i class="customicon-air-condition"></i>
                        <h3>Air Conditioning</h3>
                        <p>Our rooms are fully air-conditioned for your comfort during your stay.</p>
                    </div>
                </div>
                <div class="col-xl-3 col-md-6">
                    <div class="box_facilities" data-cue="">
                        <i class="customicon-washing-machine"></i>
                        <h3>Laundry Service</h3>
                        <p>Convenient laundry service to ensure your stay is hassle-free.</p>
                    </div>
                </div>
            </div>
            {/* <!-- /Row --> */}
        </div>
        {/* <!-- /container--> */}

        <div class="marquee">
            <div class="track">
                <div class="content">&nbsp;Relax Enjoy Luxury Holiday Travel Discover Experience Relax Enjoy Luxury Holiday Travel Discover Experience Relax Enjoy Luxury Holiday Travel Discover Experience Relax Enjoy Luxury Holiday Travel Discover Experience</div>
            </div>
        </div>
        {/* <!-- /marquee--> */}

        <div class="bg_white">
            <div class="pinned-image pinned-image--medium">
                <div class="pinned-image__container">
                    <img src="./img/parallax_bg.jpg" alt=""/>
                    <div class="pinned-image__container-overlay"></div>
                </div>
                <div class="pinned_over_content">
                    <div class="title white">
                        <small data-cue="slideInUp" data-delay="200">Luxury Hotel Experience</small>
                        <h2 data-cue="slideInUp" data-delay="300">Enjoy in a very<br/> Immersive Relax</h2>
                    </div>
                </div>
            </div>
            {/* <!-- /pinned content --> */}
        </div>
        {/* <!-- /bg_white--> */}

        {/* <div class="container margin_120" id="gallery">
            <div class="row">
                <div class="title col-12 text-center mb-5">
                    <small data-cue="slideInUp">Luxury B&B Experience</small>
                    <h2 data-cue="slideInUp" data-delay="100">Interior Gallery</h2>
                </div>
            </div>
            <div data-cues="zoomIn">
                <div class="">
                    <div class="item">
                        <img src="./img/gallery/1.jpg" alt=""/>
                    </div>
                    <div class="item">
                        <img src="./img/gallery/2.jpg" alt=""/>
                    </div>
                    <div class="item">
                        <img src="./img/gallery/3.jpg" alt=""/>
                    </div>
                    <div class="item">
                        <img src="./img/gallery/4.jpg" alt=""/>
                    </div>
                    <div class="item">
                        <img src="./img/gallery/5.jpg" alt=""/>
                    </div>
                </div>
            </div>
            <div class="text-center mt-5">
                <a data-fslightbox="gallery_1" data-type="image" href="./img/gallery/1.jpg" class="btn_1 outline">
                    FullScreen Gallery
                </a>
                <a data-fslightbox="gallery_1" data-type="image" href="./img/gallery/2.jpg"></a>
                <a data-fslightbox="gallery_1" data-type="image" href="./img/gallery/3.jpg"></a>
                <a data-fslightbox="gallery_1" data-type="image" href="./img/gallery/4.jpg"></a>
                <a data-fslightbox="gallery_1" data-type="image" href="./img/gallery/5.jpg"></a>
            </div>
        </div> */}
 <div className="container margin_120" id="gallery">
      <div className="row">
        <div className="title col-12 text-center mb-5">
          <small data-cue="">Luxury B&B Experience</small>
          <h2 data-cue="" data-delay="100">Interior Gallery</h2>
        </div>
      </div>
      <Swiper
        spaceBetween={20}
        slidesPerView={3}
        breakpoints={{
          640: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
        }}
      >
        <SwiperSlide>
          <img src="./img/gallery/g1.jpg" alt="Gallery Item 4" className="item" />
        </SwiperSlide>
        <SwiperSlide>
          <img src="./img/gallery/g2.jpg" alt="Gallery Item 5" className="item" />
        </SwiperSlide>
        <SwiperSlide>
          <img src="./img/gallery/g3.jpg" alt="Gallery Item 5" className="item" />
        </SwiperSlide>
        <SwiperSlide>
          <img src="./img/gallery/g1.jpg" alt="Gallery Item 1" className="item" />
        </SwiperSlide>
        <SwiperSlide>
          <img src="./img/gallery/g2.jpg" alt="Gallery Item 2" className="item" />
        </SwiperSlide>
        <SwiperSlide>
          <img src="./img/gallery/g3.jpg" alt="Gallery Item 3" className="item" />
        </SwiperSlide>
        
      </Swiper>
      {/* <div className="text-center mt-5">
        <a
          href="./img/gallery/1.jpg"
          className="btn_1 outline"
          data-type="image"
        >
          FullScreen Gallery
        </a>
      </div> */}
    </div>

        {/* <!-- /container gallery--> */}

        <div class="bg_white" id="amenities">
            <div class="container margin_120_95">
                <div class="row justify-content-between d-flex align-items-center add_bottom_90">
                    <div class="col-lg-6">
                        <div class="pinned-image rounded_container pinned-image--small mb-4">
                            <div class="pinned-image__container">
                                <img src="./img/h3.jpg" alt=""/>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-5">
                    <div class="title">
                            {/* <small>Local Activities</small> */}
                            <h3>Upstream's Hospitality</h3>
                            <p>Upstream ensures a seamless and comfortable experience for its visitors and partners. Our dedicated room service is available to cater to your needs, offering timely and professional assistance. Whether it’s a meal, refreshments, or special requests, our team is here to provide exceptional service.</p>
                        </div>
                    </div>
                </div>
                {/* <!-- /row--> */}
                <div class="row justify-content-between d-flex align-items-center">
                    <div class="col-lg-6 order-lg-2">
                        <div class="pinned-image rounded_container pinned-image--small mb-4">
                            <div class="pinned-image__container">
                                <img src="./img/h4.jpg" alt=""/>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-5 order-lg-1">
                        <div class="title">
                            {/* <small>Local Activities</small> */}
                            <h3> Excellence Service</h3>
                            <p>Embrace the pinnacle of hospitality with our signature services. We offer express dry cleaning, shoe shine service, and pressing on request. Our dedicated floor managers ensure swift response to any needs, while our evening turndown service includes weather updates and activity recommendations for the following day. Experience thoughtful touches like complimentary morning newspapers and evening chocolates that make your stay memorable.</p>
                        </div>
                    </div>
                </div>
                {/* <!-- /row--> */}

                <hr class="more_margin"/>

                
            {/* <!-- /container--> */}
        </div>
        {/* <!-- /bg_white --> */}

        <div class="contactcontainer" id="contacts">
            <div class="row justify-content-between address">
                <div class="col-xl-4">
                    <div data-cue="">
                        <div class="title">
                            <small>Luxury Suites Experience</small>
                            <h2>Address</h2>
                        </div>
                        <p style={{textAlign:'left'}}>Srinvas garden layout, Sathnur Village,<br/> Bengaluru, Sathanur, Karnataka 560064</p>
                        <div class="phone_element no_borders"><a href="tel://423424234"><i class="bi bi-telephone"></i><span><em>Bookings</em>+91 8618166429 <br/>+91 8310722558</span></a></div>
                        <div class="phone_element no_borders"><a href="mailto:info@domain.com"><i class="bi bi-envelope"></i><span><em>Questions</em>upstreamsuites@gmail.com</span></a></div>
                        <div class="social mt-1">
                            <ul>
                                <li><a href="#0"><i class="bi bi-instagram"></i></a></li>
                                <li><a href="#0"><i class="bi bi-whatsapp"></i></a></li>
                                <li><a href="#0"><i class="bi bi-facebook"></i></a></li>
                                <li><a href="#0"><i class="bi bi-twitter-x"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-xl-7" id="booking_section">
    <ul class="nav nav-tabs" id="customTab" role="tablist">
       
        <li class="nav-item" role="">
            <button class="nav-link active" id="second_tab" data-bs-toggle="tab" data-bs-target="#second_tab_pane" type="button" role="tab" aria-controls="second_tab_pane" aria-selected="true">Contact Us</button>
        </li>
    </ul>
    {/* <!-- /tabs --> */}
    <div className="tab-content">
  <div
    className="tab-pane fade show active"
    id="second_tab_pane"
    role="tabpanel"
    aria-labelledby="second_tab"
    tabIndex="0"
  >
    <div className="contacts_wrapper">
      <div id="message-contact">{status}</div>
      <form
        onSubmit={(e) => {
          e.preventDefault(); // Ensure event is passed correctly
          handleSubmit(e); // Pass the event object to handleSubmit
          setFormData({ fullname: "", lastname: "", email: "", phone: "", message: "" }); // Clear form
        }}
        id="contactform"
        autoComplete="off"
      >
        <div className="row">
          <div className="col-sm-6">
            <div className="form-floating mb-4">
              <input
                className="form-control"
                type="text"
                id="name_contact"
                name="fullname"
                placeholder="Name"
                value={formData.fullname}
                onChange={handleChange}
              />
              <label htmlFor="name_contact">Name</label>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-floating mb-4">
              <input
                className="form-control"
                type="text"
                id="lastname_contact"
                name="lastname"
                placeholder="Last Name"
                value={formData.lastname}
                onChange={handleChange}
              />
              <label htmlFor="lastname_contact">Last name</label>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-floating mb-4">
              <input
                className="form-control"
                type="email"
                id="email_contact"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
              />
              <label htmlFor="email_contact">Email</label>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-floating mb-4">
              <input
                className="form-control"
                type="text"
                id="phone_contact"
                name="phone"
                placeholder="Telephone"
                value={formData.phone}
                onChange={handleChange}
              />
              <label htmlFor="phone_contact">Telephone</label>
            </div>
          </div>
        </div>
        <div className="form-floating mb-4">
          <textarea
            className="form-control"
            placeholder="Message"
            id="message_contact"
            name="message"
            value={formData.message}
            onChange={handleChange}
          ></textarea>
          <label htmlFor="message_contact">Message</label>
        </div>
        <hr />
        <button
          type="submit"
          className="btn btn-primary"
          style={{
            backgroundColor: "#ffc107",
            color: "#fff",
            border: "none",
            padding: "10px 20px",
            fontSize: "16px",
            cursor: "pointer",
            borderRadius: "5px",
          }}
        >
          Send
        </button>
      </form>
    </div>
  </div>
</div>

    
</div>

            </div>
            {/* <!-- /row --> */}
            {/* <div class="map_contact">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3021.4364241114604!2d-73.96780638459853!3d40.774418641731515!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c258a29d3847f5%3A0x564dfbba0141774a!2s5th%20Ave%2C%20New%20York%2C%20NY%2C%20Stati%20Uniti!5e0!3m2!1sit!2ses!4v1661414716655!5m2!1sit!2ses"
          width="600"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade" ></iframe>
    </div> */}
      <div className="map_contact">
        <iframe
           src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3885.6375813723184!2d77.6368693!3d13.1221306!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae196a664d8921%3A0x17e3b126c64c6801!2sUpstream%20suites!5e0!3m2!1sen!2sin!4v1736247556326!5m2!1sen!2sin" 
          width="800"
          height="450"
          style={{ border: '0' }} // Corrected style here
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    {/* <!--/map_contact --> */}
    <div class="copy">
   
        <p class="container">
          Copyright 2025, <a href="https://excerptech.com/"   target="_blank" style={{color:'white'}}>
       Designed By Excerpt Technologies
    </a>
        </p>
     
    </div>
    {/* <!--/copyright line --> */}
        </div>
      </div>
    </div>
  );
}

export default App;
